import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEdgeTop32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconEdgeTop32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.5 20.25a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m1.25-3.75a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m19 0a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0M6.5 10.25a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m20.25 1.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m-14 14a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m8.75-1.25a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m-3.75 1.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m7.75-5.25a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m-3.25-13.5a1 1 0 1 0 0-2h-12a1 1 0 1 0 0 2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEdgeTop32);
